import { Joyride } from "react-joyride";
import { useFeatureFlag } from "@/hooks/useFeatureFlag";
import { FEATURE_FLAGS } from "@/lib/featureFlags";
import { useTourState } from "@/hooks/useTourState";
import { useGuideTourSteps } from "./useGuideTourSteps";
import { tourOptions, tourStyles } from "./tourStyles";
import { useTourCallback } from "./useTourCallback";
import { useTranslation } from "react-i18next";

export function GuideTour() {
  const { t } = useTranslation();
  const { enabled: tourEnabled, isLoading } = useFeatureFlag(
    "app-tour",
    FEATURE_FLAGS["app-tour"] ?? false,
  );
  const { isRunning, completeTour } = useTourState("guide");
  const steps = useGuideTourSteps();

  // TES-1659: shared Joyride onEvent — scroll the step target's real scroll
  // container into view (joyride's window-only engine misses CheckMaty's <main>
  // scroller) + finish bookkeeping. Shared with DashboardTour to avoid a clone.
  const handleCallback = useTourCallback(completeTour);

  if (!tourEnabled || isLoading) {
    return null;
  }

  return (
    <Joyride
      steps={steps}
      run={isRunning}
      continuous
      scrollToFirstStep
      onEvent={handleCallback}
      options={tourOptions}
      styles={tourStyles}
      locale={{
        back: t("tour.buttons.back"),
        close: t("tour.buttons.finish"),
        last: t("tour.buttons.finish"),
        next: t("tour.buttons.next"),
        skip: t("tour.buttons.skip"),
      }}
    />
  );
}
